import React from 'react';
import AiSkeleton, { SkeletonText, SkeletonCircle } from '../../common/AiSkeleton';

/**
 * 질의 현황(Inquiry History) 목록을 위한 스켈레톤 UI.
 * InquiryCard의 레이아웃을 모사합니다.
 */
const HistoryListSkeleton = ({ count = 5 }) => {
    return (
        <div className="grid gap-4 w-full">
            {Array.from({ length: count }).map((_, i) => (
                <div 
                    key={i} 
                    className="bg-white border border-gray-100 p-5 rounded-3xl shadow-sm flex flex-col gap-4"
                >
                    <div className="flex justify-between items-start gap-4">
                        <div className="flex items-center gap-3 flex-1">
                            {/* 상태 배지 스켈레톤 */}
                            <AiSkeleton variant="rect" className="w-16 h-6 rounded-full" />
                            {/* 질문 제목 스켈레톤 */}
                            <SkeletonText width="60%" className="h-5" />
                        </div>
                        {/* 날짜 스켈레톤 */}
                        <SkeletonText width="80px" className="h-3" />
                    </div>

                    {/* 카드 하단 정보 (답변 요약 등) */}
                    <div className="space-y-2 opacity-50">
                        <SkeletonText width="90%" />
                        <SkeletonText width="40%" />
                    </div>

                    <div className="flex justify-between items-center pt-2 border-t border-gray-50 mt-1">
                        <div className="flex items-center gap-2">
                            <SkeletonCircle size="24px" />
                            <SkeletonText width="60px" />
                        </div>
                        <AiSkeleton variant="rect" className="w-20 h-8 rounded-lg" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default HistoryListSkeleton;
